export default {
  name: "OtpDelayFunction",
  data: function () {
    return {
      otpJustSent: false,
      enableButtonTime: 10000,
    };
  },
  mounted() {
    this.getEnableButtonTime();
  },
  methods: {
    otpSent() {
      this.otpJustSent = true;
      setTimeout(() => (this.otpJustSent = false), this.enableButtonTime);
    },
    getEnableButtonTime() {
      let sett = this.$store.getters.getSettings;
      if (sett && sett.otpDisableResendSeconds)
        this.enableButtonTime = sett.otpDisableResendSeconds * 1000;
      // convert to milliseconds
      else this.enableButtonTime = 10000;
    },
  },
};
